import { Alert, Box, Breadcrumbs, Button, Grid, Link, Typography } from '@mui/material'
function BackOfficeHeaderCompany() {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				bgcolor: 'grey.100',
				padding: '0.5rem',
				paddingBlockEnd: '0.1rem',
			}}
		>
			<Grid
				container
				xs={12}
				sx={{ display: 'flex' }}
			>
				<Grid
					item
					xs={4}
					sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
				>
					<Breadcrumbs aria-label='breadcrumb'>
						<Link
							underline='hover'
							color='inherit'
							href='/'
						>
							<Typography></Typography>
						</Link>
						<Link
							underline='hover'
							color='inherit'
							href='/'
						>
							<Typography>...</Typography>
						</Link>
						<Typography color='text.primary'>Empresa</Typography>
					</Breadcrumbs>
				</Grid>
			</Grid>
			<Grid
				container
				sx={{ display: 'flex', marginBlock: '0.2rem' }}
				spacing={2}
				xs={12}
			>
				<Grid
					item
					xs={4}
				>
					<Typography variant='h4'>Transol</Typography>
				</Grid>
				<Grid
					item
					xs={7.5}
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-end',
						marginInline: '0.5rem',
						paddingBlockStart: '0',
					}}
				>
					<Button size='medium'>Desativar Empresa</Button>
					<Box component={'div'}>
						<Alert
							severity='success'
							sx={{
								padding: '0 16px',
								height: '37px',
								fontFamily: 'var(--font-family)',
								fontSize: '14px',
								fontWeight: 500,
								lettrerSpacing: '0.15px',
								lineHeight: '150%',
							}}
						>
							Empresa Ativa
						</Alert>
					</Box>
				</Grid>
			</Grid>
		</Box>
	)
}

export default BackOfficeHeaderCompany
